import {IOrpyxApplicationStore} from "../../store/application.reducers";

export const getDoctorDashboardState = (state: IOrpyxApplicationStore) => state.doctorsDashboard;